// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2_5NL","content":"LoadingAlert_content__1CbEu"};